module.exports = __webpack_public_path__ + "img/future-hr.76eef64d.png";